export default "__VITE_ASSET__okkZDr7s__"